/**
 * One-click starting points offered when an avatar has no blocks yet.
 *
 * They used to live in the create wizard, which asked for blocks before the
 * avatar existed. Blocks are now written inside the avatar, so the offer moved
 * with them — it is worth keeping, because a blank editor is the hardest part.
 */
export const STARTER_BLOCKS = [
  {
    title: "Identity and Role",
    markdown:
      "You are a helpful agent for [business].\n\nYour main role is to guide users clearly and solve requests quickly.",
  },
  {
    title: "Tone and Style",
    markdown:
      "Use a friendly, professional tone.\n\nKeep answers short, clear, and practical. Avoid jargon.",
  },
  {
    title: "Boundaries",
    markdown:
      "If information is missing, ask a follow-up question.\n\nDo not invent data.\n\nEscalate sensitive requests to a human agent.",
  },
  {
    title: "Response Structure",
    markdown:
      "Structure responses in this order:\n1. Direct answer\n2. Key details\n3. Next step for the user",
  },
];
